import React, { useEffect, useState } from 'react';
import { Card, Col } from 'reactstrap';
import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import axios, { AxiosError } from "axios";
import { baseUrl } from '../../../../Utils/Baseurl/Baseurl';
import CommonCardHeader from '../../../../Utils/CommonComponents/CommonCardHeader';
import CommonTable from '../../../Tables/ReactstrapTables/BasicTables/Common/CommonTable';
import { bookedTokenTable } from '../../../../Data/Tables/ReactstrapTables/BasicTables';
import { Btn } from '../../../../AbstractElements';
import { useNavigate } from "react-router-dom";
import { Modal, Spinner } from 'react-bootstrap';
import api from "../../../../services/api";
interface CustomJwtPayload {
    id: string;
}

export default function BookedTokens() {
    const navigate = useNavigate();
    const [tokens, setTokens] = useState<any[]>([]);
    const [verificationStatuses, setVerificationStatuses] = useState<{ [key: string]: number }>({});
    const [loading, setLoading] = useState(false);

    const fetchUserTokens = async () => {
        const token = localStorage.getItem("token");
        console.log("🔹 Token from Local Storage:", token);

        if (!token) {
            toast.error("User is not logged in!");
            return;
        }

        try {
            const decoded = jwtDecode<CustomJwtPayload>(token);
            console.log("✅ Decoded Token:", decoded);

            const userId = decoded?.id;
            if (!userId) {
                toast.error("Invalid token, user ID not found!");
                return;
            }

            console.log("🔹 Fetching tokens for userId:", userId);
            const response = await api.get(`${baseUrl}tokenregistration/usertokens`, {
                headers: { Authorization: `Bearer ${token}` },  // Ensure correct format
                params: { userId },
            });

            console.log("✅ Tokens received:", response.data);
            setTokens(response.data.data);
        } catch (error) {
            console.error("❌ Error fetching user tokens:", error);

            const axiosError = error as AxiosError;
            if (axiosError?.response?.status === 403) {
                toast.error("Your account has been disabled. Please contact support.");
                localStorage.removeItem("token");
                setTimeout(() => navigate(`/login`), 1500);
                return;
            }

            toast.error("Error fetching user tokens. Please try again later.");
        }
    };

    useEffect(() => {
        fetchUserTokens();
    }, []);


    const handleDownloadPdf = async (tokenId: number) => {
        setLoading(true); // Show loading modal
        try {
            const response = await api.get(`${baseUrl}tokenpdf/generate-pdf/${tokenId}`, {
                responseType: 'blob',
            });

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `token_${tokenId}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            toast.success("PDF downloaded successfully!");
        } catch (error: any) {
            toast.error("Error downloading PDF: " +
                (error.response?.data?.message || error.message)
            );
        } finally {
            setLoading(false); // Hide loading modal
        }
    };


    return (
        <>

            {/* Loading Modal */}
            <Modal show={loading} centered>
                <Modal.Body className="text-center">
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                    <p className="mt-2">Generating PDF, please wait...</p>
                </Modal.Body>
            </Modal>
            <Col sm={12} className='mt-0'>
                <Card>
                    <CommonCardHeader title="Booked Tokens" />
                    <div className="table-responsive">
                        <CommonTable headData={bookedTokenTable} headRowClass="border-bottom-secondary border-top-0">
                            {tokens.map((token, index) => (
                                <tr key={token.id}>
                                    <th scope="row">{index + 1}</th>
                                    <td>{new Date(token.appointmentdate).toLocaleDateString("en-GB")}</td>
                                    <td>{token.prefix}-{token.tokenno}</td>
                                    <td>
                                        <Btn color="primary" onClick={() => handleDownloadPdf(token.id)}>
                                            Download Token
                                        </Btn>
                                    </td>
                                    <td>
                                        {/* {verificationStatuses[token.id] !== 1 && ( */}

                                        <Btn onClick={() => navigate(`${process.env.PUBLIC_URL}/app/medicalcertificates/${token.id}`)}>
                                            Upload Certificates
                                        </Btn>
                                        {/* )} */}
                                    </td>
                                    <td>
                                        {token.medicine.length > 0 && token.medicine[0].status === 1 && token.medicine[0].finalstatus !== 1 && (
                                            <Btn
                                                color="success"
                                                onClick={() => navigate(`${process.env.PUBLIC_URL}/indentform/${token.id}`)}
                                            >
                                                Fill Indent Details
                                            </Btn>
                                        )}
                                    </td>


                                </tr>
                            ))}
                        </CommonTable>
                    </div>
                </Card>
            </Col>
        </>
    );
}
